import React from 'react';
import Section from './Section';
import Container from 'react-bootstrap/Container';
import SectionHeader from './SectionHeader';
import Testimonials from './Testimonials';

function TestimonialsSection(props) {
  return (
    <Section
      bg={props.bg}
      textColor={props.textColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container>
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={2}
          spaced={true}
          className="text-center"
        ></SectionHeader>
        <Testimonials
          items={[
            {
              avatar: 'https://uploads.divjoy.com/pravatar-150x-5.jpeg',
              name: 'Sarah Kline',
              testimonial:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.',
              company: 'Company',
            },
            {
              avatar: 'https://uploads.divjoy.com/pravatar-150x-48.jpeg',
              name: 'Shawna Murray',
              testimonial:
                'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum consequatur numquam aliquam tenetur ad amet inventore hic beatae, quas accusantium perferendis sapiente explicabo, corporis totam!',
              company: 'Company',
            },
            {
              avatar: 'https://uploads.divjoy.com/pravatar-150x-12.jpeg',
              name: 'Blake Elder',
              testimonial:
                'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum consequatur numquam aliquam tenetur ad amet inventore hic beatae.',
              company: 'Company',
            },
          ]}
        ></Testimonials>
      </Container>
    </Section>
  );
}

export default TestimonialsSection;
